import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { RecipientType } from '../../api/model/common/RecipientType';
import integrations from '../utils/integrations';
import { jsx as _jsx } from "react/jsx-runtime";
const getBannerTextKey = appId => integrations.isGoogleChatAppId(appId) ? 'spacesLoadingBannerText' : 'channelsLoadingBannerText';
function ThirdPartyOutageBanner({
  appId,
  isShown,
  recipientType
}) {
  const bannerType = recipientType === RecipientType.USER ? 'usersLoadingBannerText' : getBannerTextKey(appId);
  return isShown ? /*#__PURE__*/_jsx(UIAlert, {
    "data-test-id": "ui-alert",
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `shareWithThirdPartyComponentLibrary.thirdPartyOutageError.bannerTitle`
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `shareWithThirdPartyComponentLibrary.thirdPartyOutageError.${bannerType}`
    })
  }) : null;
}
export default ThirdPartyOutageBanner;